export default "__VITE_ASSET__5ZpGSU_9__"